import React from 'react';
import _ from 'lodash';
import { Form } from 'semantic-ui-react';
import { ATTRIBUTE_TYPE, ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING } from '../../../../HelperMethods/FormUtils';
import CopyComponent from '../../../common/CopyComponent';

export default function TaskNumberComponent({ task, attributeObj, formik }) {
  const taskNumber = _.get(formik.values, attributeObj.attributeName);
  return (
    <Form.Field>
      <>
        <label>{attributeObj.displayName}</label>
        <CopyComponent textToCopy={task?.taskNumber} />
        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.STRING]({ disabled: true, value: taskNumber })}
      </>
    </Form.Field>
  );
}
